(function(){
	// クッキー操作のヘルパー関数
	function setCookie(name, value, options) {
		options = options || {};
		let cookieString = name + '=' + encodeURIComponent(value);
		
		if (options.expires) {
			cookieString += '; expires=' + options.expires.toUTCString();
		}
		if (options.path) {
			cookieString += '; path=' + options.path;
		}
		if (options.domain) {
			cookieString += '; domain=' + options.domain;
		}
		if (options.secure) {
			cookieString += '; secure';
		}
		
		document.cookie = cookieString;
	}

	function getCookie(name) {
		const nameEQ = name + '=';
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}
		return null;
	}

	// キャンペーンパラメータ引継ぎ用
	addURLParameter();

	function addURLParameter(){
		// ルートコード追加
		if(location.pathname.split('/')[1] === 'ladies') {
			rootQuery();
		}

		// 別ドメインにキャンペーンパラメータ付与
		var brandUrl = [
			'www.aderans.co.jp',
			'www.aderans.jp',
			'www.aderans.com'
		];
		var hostname = location.hostname;
		var idxChk = brandUrl.indexOf(hostname);

		if(idxChk > -1) brandUrl.splice(idxChk, 1);

		for(var i=0; i < brandUrl.length; i++) {
			var anchor = document.getElementsByTagName('a');
			for(var j=0; j < anchor.length; j++) {
				var regExp = new RegExp(brandUrl[i]);
				var href = anchor[j].href;

				if((href.match(regExp) || []).length > 0) {
					var query = (href.match(/\?/) || []).length > 0 ? '&' : '?';

					anchor[j].href += query+'utm_source='+hostname+'&utm_medium=referrer&brandFlag=true';
				}
			}
		}
		// キャンペーンパラメータ引き継ぎ
		addUtmCookies();

		function addUtmCookies(){
			if(getQuery()['utm_source'] && getQuery()['utm_medium']) {
				var cookieDate = new Date();
				cookieDate.setTime(cookieDate.getTime() + (60 * 60 * 1000)); // 1時間

				setCookie('aderans_utm_source', getQuery()['utm_source'], { path:'/', expires:cookieDate });
				setCookie('aderans_utm_medium', getQuery()['utm_medium'], { path:'/', expires:cookieDate });

				if(getQuery()['utm_campaign']) {
					setCookie('aderans_utm_campaign', getQuery()['utm_campaign'], { path:'/', expires:cookieDate });
				}
				if(getQuery()['utm_content']) {
					setCookie('aderans_utm_content', getQuery()['utm_content'], { path:'/', expires:cookieDate });
				}
			}
			if(getCookie('aderans_utm_source') && getCookie('aderans_utm_medium')) {
				var cookie = {
					source: getCookie('aderans_utm_source'),
					medium: getCookie('aderans_utm_medium'),
					campaign: getCookie('aderans_utm_campaign') !== null ? getCookie('aderans_utm_campaign') : null,
					content: getCookie('aderans_utm_content') !== null ? getCookie('aderans_utm_content') : null
				};

				var anchors = document.querySelectorAll('a[href]');
				for(var i = 0; i < anchors.length; i++) {
					run(anchors[i], cookie);
				}
			}

			function run(_that, _cookie){
				var $anchor = _that.getAttribute('href');
				var hostPathName = '',
					queryStrings = '',
					hash = '',
					url = '';

				var brandFlag = ($anchor.match(/brandFlag=true/) || []).length;

				if(brandFlag === 0 && $anchor.match(/e-check\.jp/g)) {
					hostPathName = $anchor.split('?')[0];
					var source = _cookie.source !== null ? '&utm_source='+_cookie['source'] : '';
					var medium = _cookie.medium !== null ? '&utm_medium='+_cookie['medium'] : '';
					var campaign = _cookie.campaign !== null ? '&utm_campaign='+_cookie['campaign'] : '';
					var content = _cookie.content !== null ? '&utm_content='+_cookie['content'] : '';

					if($anchor.split('?').length > 1) {
						queryStrings = $anchor.split('?')[1];

						if($anchor.match(/#/)) {
							queryStrings = $anchor.split('?')[1].split('#')[0];
							hash = '#'+$anchor.split('#')[1];
						}
						url = hostPathName+'?'+queryStrings+source+medium+campaign+content+hash;
					} else {
						if($anchor.match(/#/)) {
							hostPathName = $anchor.split('#')[0];
							hash = '#'+$anchor.split('#')[1];
						}
						source = '?'+source.substr(1);
						url = hostPathName+source+medium+campaign+content+hash;
					}
					if((url.match(/undefined/) || []).length === 0) {
						_that.setAttribute('href', url);
					} else {
						// urlパラメータにundefinedが含まれていたらエラーをGAに送信する
						if(ga) ga('send', 'CampaignParameterError', $anchor, location.href);
					}
				}
			}
		}
	}
	function aync(_url, _callback){
		var doc = document,
			tag = 'script',
			item = doc.createElement(tag),
			firstScript = doc.getElementsByTagName(tag)[0];
		item.type = 'text/javascript';
		item.src = _url;

		if(_callback) {
			item.addEventListener('load', function(){
				_callback();
			}, false);
		}
		firstScript.parentNode.insertBefore(item, firstScript);
	}
	function getQuery(){
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	// ルートコード追加
	function rootQuery(){
		var anchors = document.querySelectorAll('a[href]');
		for(var i = 0; i < anchors.length; i++) {
			var href = anchors[i].href;
			var params = href.split('?');
			var echeckUrl = 'e-check.jp';
			var codeUrl = 'route_cd';
			var domainChk = href.indexOf(echeckUrl);
			var codeChk = href.indexOf(codeUrl);

			var hostPathName = '',
				queryStrings = '',
				url = '';

			if(domainChk > 0 && codeChk < 0) {
				if(params.length > 1) {
					hostPathName = params[0];
					queryStrings = params[1];
					url = hostPathName+'?route_cd=LJ&'+queryStrings;
				} else {
					url = href+'?route_cd=LJ';
				}
				anchors[i].href = url;
			}
		}
	}
})();